@if (image && !imageFailed) {
<p-avatar
  [image]="image"
  styleClass="mr-2"
  [size]="size"
  shape="circle"
  (onImageError)="onImageError()" />
} @else if (label) {
<p-avatar [label]="label" styleClass="mr-2" [size]="size" shape="circle" />
} @else {
<p-avatar icon="pi pi-user" styleClass="mr-2" [size]="size" shape="circle" />
}
